/* National Canvas "Ask a Question" lead overlay. Added 2026-09-16.
   Rewritten the same day, see THE CAPTCHA RULE below.
   Shading chips removed the same day at Niko's request.

   Opens from the header pill, and once on its own per visitor per week.

   ===============================================================
   THE CAPTCHA RULE. READ THIS BEFORE TOUCHING THE SUBMIT PATH.
   ===============================================================
   This store has Shopify storefront spam protection switched on. The page
   loads ce_storefront_forms_captcha_hcaptcha, whose bootstrap binds exactly
   these selectors:

     form[action*='/contact'] input[name='form_type'][value='contact']
     form[action*='/contact'] input[name='form_type'][value='customer']

   Both of ours. That script works by intercepting the form's own submit
   event, fetching an hCaptcha token, writing it into a hidden field and THEN
   letting the form go. So:

     A form posted with fetch() carries no token, and /contact answers 403
     with a challenge page. Nothing is emailed. No customer is created.

   Worse, a 403 RESOLVES the fetch promise. The first version of this file
   treated "the request completed" as success, so the visitor was shown a
   thank-you while the lead was thrown away. That is exactly what happened to
   the first 2026-09-16 test submission.

   The note inherited from the colour-card form, "do NOT gate success on
   response.status", was true when it was written and is dangerously wrong
   under captcha.

   THEREFORE: this form submits NATIVELY. No fetch, no preventDefault, no
   capture-phase interception. The page really does reload, which is fine,
   because the Liquid renders the thank-you from form.posted_successfully? and
   this file reopens the dialog on the way back. The half second of "nothing
   happening" after the click is the captcha doing its job. Do not optimise it
   away. If you ever need this to be AJAX again, the token has to come from
   Shopify.captcha.protect() first, and you must treat any non-2xx as failure.

   Verified working 2026-09-16: two live submissions landed at sunshades@ with
   name, email, phone and boat intact.
   =============================================================== */
(function () {
  'use strict';

  var SEEN_KEY = 'nc_q_seen';   // last time the overlay opened by itself
  var DONE_KEY = 'nc_q_done';   // this visitor already sent us something
  var WEEK = 7 * 24 * 60 * 60 * 1000;
  var QUARTER = 90 * 24 * 60 * 60 * 1000;
  var IDLE_MS = 30000;          // 30s on the page before it opens itself

  var dialog = document.getElementById('nc-quote');
  if (!dialog) return;

  var form = document.getElementById('nc-q-form');
  var opened = false;
  var autoFired = false;
  var lastFocus = null;

  /* localStorage throws outright in some privacy modes, so every read and
     write goes through these. A visitor we cannot remember simply sees the
     overlay again next week. */
  function get(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function set(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }
  function freshEnough(key, window_ms) {
    var raw = get(key);
    if (!raw) return false;
    var then = parseInt(raw, 10);
    if (!then) return false;
    return (Date.now() - then) < window_ms;
  }

  /* ---------------------------------------------------------------
     Open and close
     --------------------------------------------------------------- */
  function open(source) {
    if (opened) return;
    lastFocus = document.activeElement;
    opened = true;

    var hidden = form && form.querySelector('input[name="contact[Source]"]');
    if (hidden) hidden.value = source;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('data-nc-fallback', '');
      dialog.setAttribute('open', '');
    }
    document.documentElement.style.overflow = 'hidden';

    var first = dialog.querySelector('#nc-q-name') || dialog.querySelector('.nc-q-x');
    if (first) {
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
  }

  function close() {
    if (!opened) return;
    opened = false;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  dialog.addEventListener('cancel', function () {
    opened = false;
    document.documentElement.style.overflow = '';
  });

  /* Clicking the dark area around the card closes it. The scrim is the
     scrolling flex container, so only a click on the container itself counts,
     never one that bubbled up out of the card. */
  var scrim = dialog.querySelector('[data-nc-quote-scrim]');
  if (scrim) {
    scrim.addEventListener('click', function (event) {
      if (event.target === scrim) close();
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-nc-quote-open]')) {
      event.preventDefault();
      open('Header button');
      return;
    }
    if (target.closest('[data-nc-quote-close]')) {
      event.preventDefault();
      close();
    }
  });

  /* ---------------------------------------------------------------
     Submit. Tidies the payload, then gets out of the way.
     --------------------------------------------------------------- */
  if (form) {
    form.addEventListener('submit', function (event) {
      /* A bot filled the hidden field. Stop here and say nothing useful. */
      var honeypot = form.querySelector('input[name="contact[Company]"]');
      if (honeypot && honeypot.value) {
        event.preventDefault();
        close();
        return;
      }

      /* Never let the email land empty. A blank body reads as spam in the
         inbox and tells whoever picks it up nothing. */
      var body = form.querySelector('#nc-q-msg');
      if (body && !body.value.trim()) {
        var boat = form.querySelector('#nc-q-boat');
        var summary = 'Asked a question from the store overlay.';
        if (boat && boat.value.trim()) summary += ' Boat: ' + boat.value.trim() + '.';
        body.value = summary;
      }

      /* The captcha adds a visible pause before the page moves. Say so. */
      var button = form.querySelector('.nc-q-send');
      if (button) {
        button.textContent = 'Sending...';
        button.style.opacity = '.7';
        /* NOT disabled: a disabled button is excluded from the submission and
           some browsers cancel the submit outright. */
      }
      /* No preventDefault. The form goes the normal way, through hCaptcha. */
    });
  }

  /* ---------------------------------------------------------------
     Opening on its own
     Once per visitor per week, after 30 seconds, or the moment a desktop
     cursor leaves the top of the window. Never where someone is trying to
     buy, and never in the theme editor.
     --------------------------------------------------------------- */
  function pageAllowsAuto() {
    if (window.Shopify && window.Shopify.designMode) return false;
    var path = (window.location.pathname || '').toLowerCase();
    var blocked = ['/cart', '/checkout', '/account', '/challenge', '/password', '/tools', '/apps'];
    for (var i = 0; i < blocked.length; i++) {
      if (path.indexOf(blocked[i]) === 0) return false;
    }
    return true;
  }

  function autoOpen() {
    if (autoFired || opened) return;
    /* Do not stack on top of the cart drawer or anything else the theme has
       already opened. */
    if (document.querySelector('dialog[open]')) return;
    autoFired = true;
    set(SEEN_KEY, String(Date.now()));
    open('Auto-open');
  }

  /* ---------------------------------------------------------------
     Coming back from a successful post. The Liquid has already rendered the
     thank-you, so reopen the dialog over it and stop pestering this visitor.
     --------------------------------------------------------------- */
  if (dialog.querySelector('.nc-q-posted')) {
    set(DONE_KEY, String(Date.now()));
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'generate_lead', {
          event_category: 'Sunshade',
          event_label: 'Ask a Question overlay'
        });
      }
    } catch (e) {}
    open('Posted');
    return;
  }

  if (pageAllowsAuto() &&
      !freshEnough(SEEN_KEY, WEEK) &&
      !freshEnough(DONE_KEY, QUARTER)) {

    window.setTimeout(autoOpen, IDLE_MS);

    /* Exit intent, desktop only. A cursor heading off the top of the window is
       on its way to the tab bar or the close button. Touch devices have no
       equivalent, so they just get the timer. */
    var pointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
    if (pointer && pointer.matches) {
      document.addEventListener('mouseout', function (event) {
        if (event.relatedTarget || event.toElement) return;
        if (event.clientY > 12) return;
        autoOpen();
      });
    }
  }
})();